import * as React from "react";
import { SingleNavMenuContext, useInitSingleNavMenuContext } from "./useSingleNavMenuContext";
import { SingleNavMenuLink } from "../../../pages/identity/useNavMenu";

interface ContextProviderComponentProps extends React.PropsWithChildren {
  links: SingleNavMenuLink[];
  pagesWithScrolls: string[];
}
export const SingleNavMenuContextProvider: React.FC<ContextProviderComponentProps> = ({
  links,
  pagesWithScrolls,
  children,
}) => {
  const context = useInitSingleNavMenuContext(links, pagesWithScrolls);

  return <SingleNavMenuContext.Provider value={context}>{children}</SingleNavMenuContext.Provider>;
};
